import { action, makeObservable, observable } from 'mobx';

import type { Stack } from '../../../../packages/data/structures/Stack';
import { BaseSettingsScreen } from '../screen/BaseSettingsScreen';

export class BasicParametersEntity extends BaseSettingsScreen {
  readonly type = 'basic-parameters';
  @observable wellId?: number | null = null;
  @observable config?: { wellId?: number; wellboreId?: number };

  constructor(stack: Stack<BaseSettingsScreen>) {
    super(stack);

    makeObservable(this);
  }

  @action.bound
  setConfig(config?: { wellId?: number; wellboreId?: number }) {
    this.config = config;
    if (config?.wellId) {
      this.wellId = config.wellId;
    }
  }
}
